import Stepper from "bs-stepper";
import {qsa, qs, addGlobalEventListener} from '../utils/domUtils';

const initWizardForm = (formElement) => {
    let horizontalStepper = new Stepper(formElement, {
        linear: false
    });
    // navigation clicks event
    addGlobalEventListener('click', '.btn-next', () => {
        horizontalStepper.next();
    }, {}, formElement)

    addGlobalEventListener('click', '.btn-prev', () => {
        horizontalStepper.previous();
    }, {}, formElement)

    addGlobalEventListener('click', '.btn-submit', () => {
        //
    }, {}, formElement)

    formElement.addEventListener('spraydev:goto', (e) => {
        let step = e.detail.step;
        horizontalStepper.to(step)
    })
}

export default initWizardForm;
